<template>
  <div class="page-container">
    <div class="sidebar-layout">
      <aside class="sidebar-layout__menu">
        <el-menu :default-active="currentIndex" @select="menuSelect">
          <template v-for="(item, index) in leftMenus" :key="item.id">
            <el-menu-item v-if="!item.children || item.children.length === 0" :index="item.code">
              {{ item.name }}
            </el-menu-item>
            <el-sub-menu v-else :index="String(index)">
              <template #title>{{ item.name }}</template>
              <el-menu-item v-for="subItem in item.children" :key="subItem.id" :index="subItem.code">
                {{ subItem.name }}
              </el-menu-item>
            </el-sub-menu>
          </template>
        </el-menu>
      </aside>
      <div class="sidebar-layout__content">
        <div class="page-card">
          <div class="page-card__header">
            <h1 class="section-title">{{ title }}</h1>
          </div>
          <div class="page-card__body about-content">
            <div v-if="currentIndex === 'aboutUsIntroduceCode'">
              <div class="detail-content" v-html="content"></div>
              <img v-if="baseInfoUrl" :src="baseInfoUrl" alt="基金会介绍" class="about-img" />
            </div>
            <iframe
              v-if="currentIndex === 'aboutUsRuleCode'"
              class="about-iframe"
              :src="ruleUrl"
              frameborder="0"
            ></iframe>
            <div v-if="currentIndex === 'aboutUsHonorCode'" class="detail-content" v-html="content"></div>
            <div v-if="currentIndex === 'aboutUsCertificationCode'" class="detail-content" v-html="content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listAboutUsMenus, aboutUs } from '@/api/cmsApi'

export default {
  name: 'AboutUs',
  data() {
    return {
      currentIndex: 'aboutUsIntroduceCode',
      leftMenus: [],
      title: '',
      baseInfoUrl: '',
      ruleUrl: '',
      content: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.queryLeftMenu()
    },
    query() {
      aboutUs({ type: this.currentIndex }).then(res => {
        if (res.code === 200 && res.data) {
          this.baseInfoUrl = res.data.linkUrl
          this.ruleUrl = res.data.linkUrl
          this.content = res.data.content
        }
      })
    },
    queryLeftMenu() {
      listAboutUsMenus().then(res => {
        if (res.code === 200) {
          this.leftMenus = res.data || []
          if (this.leftMenus.length) {
            this.currentIndex = this.leftMenus[0].code
            this.title = this.leftMenus[0].name
            this.query()
          }
        }
      })
    },
    menuSelect(index) {
      this.leftMenus.forEach(item => {
        if (index === item.code) {
          this.title = item.name
        } else if (item.children) {
          item.children.forEach(sub => {
            if (index === sub.code) this.title = sub.name
          })
        }
      })
      this.currentIndex = index
      this.query()
    }
  }
}
</script>

<style scoped>
.sidebar-layout__menu :deep(.el-menu) {
  border-right: none;
}

.sidebar-layout__menu :deep(.el-menu-item.is-active) {
  color: var(--color-primary);
  background: rgba(192, 57, 43, 0.06);
}

.about-content {
  min-height: 400px;
}

.about-img {
  width: 100%;
  border-radius: var(--radius);
  margin-top: 20px;
}

.about-iframe {
  width: 100%;
  min-height: 800px;
  border-radius: var(--radius);
}
</style>
